<app-alert></app-alert>
<app-corporate-ui-header *ngIf="!isFullScreen()"></app-corporate-ui-header>
<div class="ebu-header-container" *ngIf="!isFullScreen()">
  <div class="container ebu-header-background">
    <div class="row ebu-header-logo hidden-sm-down">
      <div class="col-lg-6 col-md-6 hidden-sm-down">
        <a routerLink="/"><img src="/assets/images/logo-relaunch.png" alt="ebu-main-logo"></a><div class="clear"></div>
      </div>
      <div class="col-sm-12 col-xs-12 hidden-md-up">
        <a routerLink="/"><img src="/assets/images/ebu-small.png" alt="EBU"></a><div class="clear"></div>
      </div>
      <!--div class="col-lg-6 col-md-6 hidden-sm hidden-xs ebu-header-lang">


        <div class="active">EN</div>

        <div class="non-active">
          <a title="Switch to" href="/fr/home">FR</a>
        </div><div class="clear"></div>
      </div-->
    </div>
  </div>
</div>
<app-navigation *ngIf="!isFullScreen()"></app-navigation>

<div [ngClass]="{'container' : !isFullScreen()}">
  <router-outlet></router-outlet>
</div>

<app-corporate-ui-footer *ngIf="!isFullScreen()"></app-corporate-ui-footer>


// WEBPACK FOOTER //
// ./src/app/app.component.html